export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00838.e91ea07d.png";